import Axios from "axios";
import Config from "./Config.json";

const API_URL = "http://217.13.111.96:5000/api"; // Módosítsd a megfelelő szerver címre

// Cikkek lekérése
/*
export const getArticles = async (category = null, language = "en") => {
  try {
    // Kategória és az ahhoz tartozó számértékek
    const categoryMap = {
      All: 0,
      Trend: 1,
      "Machine Learning": 2,
      "AI Tools": 3,
      "AI Games": 4,
    };

    // Ellenőrizzük, hogy a kategória érvényes-e
    if (category && !categoryMap[category]) {
      console.error(`Invalid category: ${category}`);
      return []; // Ha a kategória nem érvényes, visszatérünk üres tömbbel
    }

    const categoryNumber = categoryMap[category] || 0; // Alapértelmezett kategória az "All" = 0
    console.log("Küldött adatok", categoryNumber, language); // Továbbra is logoljuk a küldött adatokat

    let url = `${API_URL}/articles`;

    // Ha van kategória, akkor hozzáadjuk a query paramétert
    url += `?category=${categoryNumber}&language=${language}`;
    console.log("Request URL:", url); // Logoljuk a végső kérés URL-jét

    const response = await Axios.get(url);

    // Ellenőrizzük, hogy a válasz adatokat tartalmaz
    if (response.status !== 200) {
      console.error("API hiba: ", response.status, response.statusText);
      return []; // Hibás válasz esetén üres tömb
    }

    console.log("Válasz:", response.data); // Logoljuk a válasz adatokat

    // Ha a válasz nem tartalmaz adatokat, hiba dobása
    if (!response.data) {
      throw new Error("Nincs adat a válaszban.");
    }

    return response.data; // Ha minden rendben, visszaadjuk az adatokat
  } catch (error) {
    console.error("Fetching error:", error);
    return []; // Hiba esetén üres tömböt adunk vissza
  }
};*/

// Cikk részleteinek lekérése (like és dislike adatokkal együtt)
export const getArticleDetails = async (language = "en") => {
  try {
    const response = await Axios.get(`${API_URL}/articleDetails`, {
      params: { language },
    });
    return response.data;
  } catch (error) {
    console.error("Hiba a cikk részleteinek lekérésekor:", error);
    throw error;
  }
};

// Első POST kérés
export const postFirstData = async (artID, image, category) => {
  try {
    const response = await Axios.post(`${API_URL}/saveArticleMetadata`, {
      artID,
      image,
      category,
    });
    return response.data;
  } catch (error) {
    console.error("Hiba az első POST kérés során:", error);
    throw error;
  }
};

// Második POST kérés
export const postSecondData = async (artID, alt, title, teaser, language) => {
  try {
    const response = await Axios.post(`${API_URL}/saveArticleDetails`, {
      artID,
      alt,
      title,
      teaser,
      language,
    });
    return response.data;
  } catch (error) {
    console.error("Hiba a második POST kérés során:", error);
    throw error;
  }
};

// Harmadik POST kérés
export const postThirdData = async (artID, title, markdown, language) => {
  try {
    const response = await Axios.post(`${API_URL}/saveArticleContent`, {
      artID,
      title,
      markdown,
      language,
    });
    return response.data;
  } catch (error) {
    console.error("Hiba a harmadik POST kérés során:", error);
    throw error;
  }
};

// ArtID-k lekérdezése
export const getArticleIds = async () => {
  try {
    const response = await Axios.get(`${API_URL}/getArticleIds`);
    return response.data;
  } catch (error) {
    console.error("Hiba az ArtID lekérdezésekor:", error);
    throw error;
  }
};

// ArtID-k lekérdezése
export const updateGlobalData = async () => {
  try {
    const response = await Axios.get(`${API_URL}/getArticleIds`);
    return response.data;
  } catch (error) {
    console.error("Hiba az ArtID lekérdezésekor:", error);
    throw error;
  }
};

// ArtID-k lekérdezése
export const updatePersonalData = async () => {
  try {
    const response = await Axios.get(`${API_URL}/getArticleIds`);
    return response.data;
  } catch (error) {
    console.error("Hiba az ArtID lekérdezésekor:", error);
    throw error;
  }
};
// 👍👎 Like és Dislike küldése az API-n keresztül
// `updateArticleVote` függvény az ügyféloldalon
export const updateArticleVote = async (artId, action, language) => {
  console.log(" Fetching data: ", artId, action, language);
  try {
    const response = await Axios.post(`${API_URL}/updatelike`, {
      artId, // ArtId kell
      action, // Like vagy Dislike
      language, // Nyelv
    });

    return response.data;
  } catch (error) {
    console.error("Hiba a like/dislike frissítés során:", error);
    throw error; // Hibát dob, hogy az ügyféloldalon kezelhető legyen
  }
};
